export default __webpack_public_path__ + "static/media/ticket_white.604f68ed.png";